var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Attach2 = function Attach2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.243 3.05a5.243 5.243 0 1 1 7.414 7.414l-6.5 6.5a3.122 3.122 0 0 1-4.414-4.414l6.5-6.5a1 1 0 1 1 1.414 1.414l-6.5 6.5a1.121 1.121 0 1 0 1.586 1.586l6.5-6.5a3.243 3.243 0 0 0-4.586-4.586l-6.5 6.5a5.364 5.364 0 1 0 7.586 7.586l6.5-6.5a1 1 0 0 1 1.414 1.414l-6.5 6.5A7.364 7.364 0 0 1 4.743 9.55l6.5-6.5Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Attach2;